import { Navigate, Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { PersikPage } from 'src/pages/persik';
import { IS_PERSIK_ROUTE_ENABLED } from 'src/persikConfig';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: IS_PERSIK_ROUTE_ENABLED ? <PersikPage /> : <Navigate to={appRoutes.root} />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const PERSIK_ROUTE: RouteProps = {
  path: appRoutes.persik.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
